<template>
<div class="main-mask">
  <nav id="navigator">
    <div class="navbar-header">
      <!-- 确保无论是宽屏还是窄屏，navbar-brand都显示 -->
      <router-link to="/" class="navbar-brand">
        <span><img style="width: 180px;height:60px;" src="../../assets/brand1.png"></span>
      </router-link>

      <!-- .navbar-toggle样式用于toggle收缩的内容，即nav-collapse collapse样式所在元素 -->
      <button class="navbar-toggle" type="button">
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
    </div>
    <!-- 屏幕宽度小于768px时，div.navbar-responsive-collapse容器里的内容都会隐藏，显示icon-bar图标，当点击icon-bar图标时，再展开。屏幕大于768px时，默认显示。 -->
    <div class="collapse navbar-collapse">
      <ul class="nav navbar-nav">
        <li>
          <div class="search-bar">
            <form @submit="clickSearch">
              <input id="search-input" type="text" placeholder="请输入您要搜索的内容...">
              <button type="submit">
                <a-icon id="search-icon" type="search" />
              </button>
            </form>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</div>
</template>

<script>
import $ from 'jquery';

export default {
  name: 'Nav',
  data() {
    return {
      queryParams: ''
    };
  },
  methods: {
    clickSearch() {
      window.location.href = 'https://fams.tech/search?query=' + $('#search-input').val();
      // this.$root.$router.push({ path: '/search', query: { query: $('#search-input').val() } });
    }
  }
};

$(document).ready(function () {
  // navigator
  var collapsedElm = document.querySelector('.navbar-collapse');
  $('.navbar-toggle').bind('click', function () {
    collapsedElm.classList.toggle('collapse');
  });
  // navigator search bar
  $('.search-bar input').bind('blur', function () {
    $('.search-bar').removeClass('input-selected');
    $('#search-icon').css('color', '#41b8e4');
  }).bind('focus', function () {
    $('.search-bar').addClass('input-selected');
    $('#search-icon').css('color', '#ee8b34');
  });

  // set navigator style
  if ($(document).scrollTop() >= 500) {
    setTopNav();
  }

  /**
   *   equals to window.onscroll = function () {}
   */
  $(window).scroll(function () {
    var h = $(document).scrollTop();
    if (h >= 500) {
      setTopNav();
    } else {
      $('#navigator').css('box-shadow', '')
        .css('-webkit-box-shadow', '')
        .css('-moz-box-shadow', '');
      if (h < 400) {
        $('#navigator').css('position', 'relative');
        $('#navigator').css('background', 'rgba(255,255,255,0)');
        $('#navigator').css('color', 'rgba(66,66,66,0)');
      } else if (h > 405 && h < 500) {
        $('#navigator').css('position', 'fixed');
        $('#navigator').css('background', 'rgba(255,255,255,0.' + (h - 400) + ')');
        $('#navigator').css('color', 'rgba(66,66,66,0.' + (h - 400) + ')');
      }
    }
  });
});

function setTopNav() {
  $('.active').css('border-top', '#fff 1px solid');
  $('#navigator').css('background', 'rgba(255,255,255,0.95)')
    .css('color', 'rgba(66,65,66,1)')
    .css('position', 'fixed');
  // 给盒子添加四周阴影的效果
  $('#navigator').css('box-shadow', '1px 1px 10px rgba(0, 0, 0, 0.5)')
    .css('-webkit-box-shadow', '1px 1px 10px rgba(0, 0, 0, 0.5)')
    .css('-moz-box-shadow', '1px 1px 10px rgba(0, 0, 0, 0.5)');
}
</script>

<style scoped>
.search-bar {
  background: transparent;
  margin-top: 5px;
  margin-right: 10px;
  float: center;
  position: relative;
  z-index: 8;
}

.search-bar form {
  height: 42px;
}

#search-icon {
  color: #41b8e4;
}

.search-bar input {
  width: 288px;
  border-radius: 42px;
  border: #41b8e4 1px solid;
  background: rgba(255, 255, 255, 0.5);
  transition: .2s linear;
  float: right;
  font-size: 15px;
  color: #202020;
}

.search-bar input:focus {
  width: 338px;
  border: #ee8b34 1px solid;
}

.search-bar button {
  background: none;
  top: -2px;
  right: 0;
}

form {
  position: relative;
  width: 300px;
  margin: 0 auto;
}

input,
button {
  border: none;
  outline: none;
}

input {
  width: 100%;
  height: 42px;
  padding-left: 13px;
  padding-right: 46px;
}

button {
  height: 42px;
  width: 42px;
  cursor: pointer;
  position: absolute;
}

nav {
  height: 66px;
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  background-color: transparent;
}

.navbar-header {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  z-index: 6;
}

.navbar-toggle {
  height: 37px;
  display: none;
  border: none;
  background-color: #41b8e4;
  border-radius: 2px;
  cursor: pointer;
}

.navbar-toggle span {
  display: block;
  width: 2em;
  margin: 3px 0;
  border-bottom: 2px solid #fff;
}

.navbar-brand {
  display: block;
  margin-left: 30px;
  padding: 0;
  position: absolute;
  top: 5px;
}

.navbar-nav li {
  display: inline-block;
  padding: 5px;
  margin-right: 20px;
  background-color: transparent;
}

.nav li a:hover {
  text-decoration: none;
  background-color: #999;
}

@media (max-width: 768px) {
  .navbar-collapse {
    border-bottom: #eee 1px solid;
    border-top: #eee 1px solid;
  }

  .active {
    border-top: #eee 1px solid;
  }

  .search-bar {
    width: 100%;
    padding-left: 5%;
    padding-right: 5%;
  }

  .search-bar form {
    width: 100%;
  }

  .search-bar form input {
    width: 100%;
  }

  .search-bar form input:focus {
    width: 100%;
    border: #ee8b34 1px solid;
  }

  nav {
    height: 66px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
  }

  .navbar-header {
    margin-top: 0;
    padding: 0;
  }

  .navbar-toggle {
    display: flex;
    position: absolute;
    right: 20px;
    top: 9px;
    flex-flow: column;
    justify-content: center;
    align-items: center;
  }

  .collapse {
    display: none;
  }

  .navbar-collapse {
    width: 100%;
    position: absolute;
    top: 66px;
    background: #fff;
  }

  .navbar-collapse li {
    width: 100%;
    text-align: center;
  }
}

.ellipsis {
  position: relative;
  width: 100%;
  max-height: 120px;
  line-height: 20px;
  overflow: hidden;
}

.ellipsis-container {
  position: relative;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6;
  font-size: 110px;
  color: transparent;
}

.ellipsis-content {
  color: #000;
  display: inline;
  vertical-align: top;
  font-size: 14px;
}

.ellipsis-ghost {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 50%;
  width: 100%;
  height: 100%;
  color: #000;
}

.ellipsis-ghost:before {
  content: "";
  display: block;
  float: right;
  width: 50%;
  height: 100%;
}

.ellipsis-placeholder {
  content: "";
  display: block;
  float: right;
  width: 50%;
  height: 120px;
}

.ellipsis-more {
  float: right;
  font-size: 14px;
  width: 110px;
  height: 20px;
  margin-top: -20px;
}

.more-text {
  color: #2bc0f7;
  text-decoration: none;
}

.main-footer {
  background: #202020;
  padding: 35px 0 0;
  color: #959595;
}

.main-footer .widget {
  padding: 0 30px;
}

.main-footer .widget .title {
  color: #ffffff;
  border-bottom: 1px solid #303030;
}
</style>
